import { Station } from '@mi-front/core';
import { isYoutubeNativeStation } from '../helpers';
import { useStations } from './useStations';

/** Stations that use the YouTube Native integration. */
export function useYoutubeNativeStations(): readonly Station[] {
  return useStations(isYoutubeNativeStation);
}
